import React, { useState } from "react";
import { useLocation } from "react-router-dom";
import "./navbar.css";

const groupList = {
  "On Site CAPs N1": 248,
  "Depósito N1": 237,
  "Soporte Home CAPs N1": 14154,
  "Laboratorio N1": 236,
  "Logística N1": 203,
  "MDA Aplicaciones N1": 240,
  "MDA ABM Usuarios N1": 239,
  "MDA Back Office N1": 241,
  "MDA CAT/CAD/CGD N1": 11558,
  "MDA VDI N1": 11381,
  "On Site PP Nivel 1": 250,
  "On Site CAT/CAD/CGD N1": 11560,
  "On Site CRUM N1": 10184,
  "On Site Urgencias 7x24 N1": 14152,
  "On Site Metro N1": 249,
  "Soporte Home CAT/CAD/CGD N1": 11562,
  "Soporte Home PP N1": 11316,
  "Soporte Técnico Online N1": 246,
  "Verificaciones tecnicas N1": 14150,
};

const Navbar = ({ onFilterChange }) => {
  const [priority, setPriority] = useState("");
  const [startDate, setStartDate] = useState("");
  const [endDate, setEndDate] = useState("");
  const [group, setGroup] = useState("");
  const [email, setEmail] = useState("");

  const location = useLocation();

  const handleFilterChange = () => {
    const filters = {
      priority,
      startDate,
      endDate,
      group,
    };

    if (location.pathname === "/individual") {
      filters.email = email;
    }

    // Llama a la función del padre para manejar el cambio de filtros
    onFilterChange(filters);
  };

  return (
    <nav>
      <div>
        <label>Prioridad:</label>
        <select value={priority} onChange={(e) => setPriority(e.target.value)}>
          <option value="">Todas</option>
          <option value="Low">Baja</option>
          <option value="Medium">Mediana</option>
          <option value="High">Alta</option>
          <option value="Urgent">Urgente</option>
          <option value="Critical">Crítica</option>
        </select>
      </div>
      <div>
        <label>Fecha de inicio:</label>
        <input
          type="date"
          value={startDate}
          onChange={(e) => setStartDate(e.target.value)}
        />
      </div>
      <div>
        <label>Fecha de fin:</label>
        <input
          type="date"
          value={endDate}
          onChange={(e) => setEndDate(e.target.value)}
        />
      </div>
      <div>
        <label>Grupo:</label>
        <select value={group} onChange={(e) => setGroup(e.target.value)}>
          <option value="">Todos</option>
          {Object.keys(groupList).map((groupName) => (
            <option key={groupList[groupName]} value={groupName}>
              {groupName}
            </option>
          ))}
        </select>
      </div>

      {location.pathname === "/individual" && (
        <div>
          <label>Email:</label>
          <input
            type="email"
            value={email}
            onChange={(e) => setEmail(e.target.value)}
          />
        </div>
      )}

      <button onClick={handleFilterChange}>Aplicar filtros</button>
    </nav>
  );
};

export default Navbar;